
const digest = '55c471d7059899a72df6a3d4f4ea477bd05add363c3690a9e9084bdbd2559e25';
const classes = {"wrapper":"_wrapper_xkfff_1","date":"_date_xkfff_10","name":"_name_xkfff_15","content":"_content_xkfff_20","attachments":"_attachments_xkfff_26","title":"_title_xkfff_32"};
const css = `._wrapper_xkfff_1 {
  display: flex;
  padding: 24px;
  flex-direction: column;
  background-color: #fbfbfd;
  border: 1px solid #eaedf3;
  margin-top: 10px;
  font-family: Rubik, "sans-serif";
}
._wrapper_xkfff_1 ._date_xkfff_10 {
  font-weight: 400;
  font-size: 12px;
  color: #3e3f42;
}
._wrapper_xkfff_1 ._name_xkfff_15 {
  font-weight: 500;
  font-size: 12px;
  color: #000000;
}
._wrapper_xkfff_1 ._content_xkfff_20 {
  margin-top: 10px;
  font-weight: 400;
  font-size: 16px;
  color: #3e3f42;
}
._wrapper_xkfff_1 ._attachments_xkfff_26 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 10px;
}
._wrapper_xkfff_1 ._attachments_xkfff_26 ._title_xkfff_32 {
  font-weight: 500;
  font-size: 14px;
  color: #1665d8;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  